var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"reporting-integration",attrs:{"title":_vm.reporting_integration.code}},[_vm._v("\n  "+_vm._s(_vm.reporting_integration.title)+"\n  "),_c('report-status',{attrs:{"status":_vm.reporting_integration.status}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }